import { createSlice } from "@reduxjs/toolkit";
import { MemberInsert,MemberUpdate ,GetMembers,DeletetMembers, IsCompanyExist} from "../api/MemberApi";

const initialState = {
  loading: false,
  contactdata:"",
  IsCompanyExistApiResponse:{} 
};

export const MemberSlice = createSlice({
  name: "MemberSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
     
      .addCase(GetMembers.pending, (state) => {
        state.loading = true;
      })
      builder.addCase(GetMembers.fulfilled, (state, action) => {
        state.loading = false;
        state.contactdata = action?.payload;
   
      })
      builder.addCase(GetMembers.rejected, (state) => {
        state.loading = false;
      })

    
      builder.addCase(MemberInsert.pending, (state) => {
        state.loading = true;
      })
      builder.addCase(MemberInsert.fulfilled, (state) => {
        state.loading = false;
      })
      builder.addCase(MemberInsert.rejected, (state) => {
        state.loading = false;
      })

     
      builder.addCase(MemberUpdate.pending, (state) => {
        state.loading = true;
      })
      builder.addCase(MemberUpdate.fulfilled, (state) => {
        state.loading = false;
      })
      builder.addCase(MemberUpdate.rejected, (state) => {
        state.loading = false;
      })

      builder.addCase(DeletetMembers.pending, (state) => {
        state.loading = true;
      })
      builder.addCase(DeletetMembers.fulfilled, (state) => {
        state.loading = false;
      })
      builder.addCase(DeletetMembers.rejected, (state) => {
        state.loading = false;
      });

      builder.addCase(IsCompanyExist.pending, (state) => {
        state.loading = true;
      })
      builder.addCase(IsCompanyExist.fulfilled, (state, action) => {
        state.loading = false;
        state.IsCompanyExistApiResponse = action?.payload
      })
      builder.addCase(IsCompanyExist.rejected, (state) => {
        state.loading = false;
      });
  },
});


export default MemberSlice.reducer;
